function getUrlParameter(param) {
  const params = new URLSearchParams(window.location.search);
  const value = params.get(param);

  // Handle boolean-style ?param
  if (value === null && params.has(param)) return true;

  return value;
}

// Standard getCookie function to check if the 3-day dismissal cookie exists
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}


function bindMediaLoaders(scope = document) {
  const media = scope.querySelectorAll("img, video");
 
  media.forEach((el) => {
    // Use the existing parent as the container
    const container = el.parentElement;

    // Insert loader only if container doesn't already have one
    let loader = container.querySelector(".loader");
    if (!loader) {
      loader = document.createElement("div");
      loader.className = "loader";
      container.prepend(loader);
    }

    const removeLoader = () => loader?.remove();

    // Prevent double-binding
    if (el.dataset.loaderBound) return;
    el.dataset.loaderBound = "true";

    if (el.tagName === "IMG") {
      if (el.complete && el.naturalWidth > 0) {
        removeLoader();
      } else {
        el.addEventListener("load", removeLoader, { once: true });
        el.addEventListener("error", removeLoader, { once: true });
      }
    }

    if (el.tagName === "VIDEO") {
      if (el.readyState >= 1) {
        removeLoader();
      } else {
        el.addEventListener("loadedmetadata", removeLoader, { once: true });
        el.addEventListener("error", removeLoader, { once: true });
      }
    }
  });
}

bindMediaLoaders();
